export enum SimpleModalEnum {
  CONFIRM
}
